export default function checkIsEmpty(str) {
  return str && str !== "";
}
